import { parse } from 'qs';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function isInApp(query) {
  if (typeof window === 'undefined') {
    if (query != null) {
      return query['os_type'] != null || query['app'] != null;
    }
    return false;
  }
  var triggered = false;
  triggered = sessionStorage['webviewTriggered'] === 'yes';
  var search = parse(location.search.slice(1));
  var isExpertCenterAndroid = search['pro_app'] != null && search['os_type'] === 'Android';
  if (!isExpertCenterAndroid && (triggered || search['os_type'] != null && search['os_type'] !== '' || search['app'] != null)) {
    sessionStorage['webviewTriggered'] = 'yes';
    return true;
  }
  return false;
}
function isIOS() {
  var initialUserAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var userAgent = typeof window !== 'undefined' ? navigator.userAgent : initialUserAgent;
  return /Mac|iPhone|iPad|iPod/i.test(userAgent);
}

export { isIOS, isInApp };
//# sourceMappingURL=dom.js.map
